const url = 'http://13.215.132.11:9001';
export const environment = {
  name: 'stg',
  production: false,
  url: `${url}/api`,
  socketUrl: `${url}`,
  frontEnd: 'https://stg-my.cryptograph.finance/auth/register'
};
